import { FC } from 'react'
import { Maybe } from 'graphql/jsutils/Maybe'
import { findCollectionTitle } from '@/page/CollectionDisplay/CollectionDisplay'
import { isHeader } from '@/page/Header'
import { PageContent } from '@/page/PageContent/PageContent'
import { isCollectionDisplay, PageDataContext, PageModel } from '@/services/RenderService'
import { CollectionDisplay } from '@/types/codegen-contentful'
import { PageContentItem } from '@/types/codegen-contentful'

interface Props {
  page: Maybe<PageModel>
  pageDataContext: Maybe<PageDataContext>
}

export const Page: FC<Props> = ({ page, pageDataContext }) => {
  if (!page || !pageDataContext) return null

  const items = page.contentCollection?.items

  return (
    <>
      {items?.map((content, contentIndex) => {
        if (!content || !content?.sys?.id) return null // this could be content that is not yet supported
        const key = `${content?.__typename}-${content?.sys?.id}`

        // Skip Contentful Headers when the next item is a CollectionDisplay that already
        // has a translated title from the CollectionService. The CollectionDisplay renders
        // its own CollectionHeader with the translated title, making the Contentful Header redundant.
        if (isHeader(content) && isNextCollectionDisplayWithTitle(items, contentIndex, pageDataContext)) {
          return null
        }

        return (
          <PageContent key={key} content={content} pageDataContext={pageDataContext} containerPosition={contentIndex} />
        )
      })}
    </>
  )
}

function isNextCollectionDisplayWithTitle(
  items: Maybe<PageContentItem>[],
  currentIndex: number,
  pageDataContext: PageDataContext,
): boolean {
  const nextItem = items[currentIndex + 1]
  if (!nextItem || !isCollectionDisplay(nextItem)) return false
  return findCollectionTitle(nextItem as CollectionDisplay, pageDataContext) !== null
}
